'use strict';

var util = require('./born.utils'),
formPrepare = require('../pages/checkout/formPrepare');
const progress = require("../progress");


function updateGovernateArea(init)
{
	var governate = getGovernateEl();
	if(!governate) {
		return;
	}
	if(window.governateArea !== undefined) {
		removeAreaSelector(init);
		updateAddressArea(init);
		return;
	}
	if(init === undefined) {
		init = false;
	}
	
	if(!governate) {
		return;
	}
	governate = governate?$(governate).val():false;
	
	var findUrl = Urls.getGovernateArea;
	if(!findUrl) {
		return;
	}
	try {
		$.ajax({
	        type: 'POST',
	        url: findUrl,
	        data:{governate:governate},
	        beforeSend:function() {
	        	removeAreaSelector(init);
	        },
	        success: afterSuccess,
	        error:function() {
	        	
	        },
	        complete:function() {
	        }
	    })
	} catch (e) {
		console.log(e);
	}
	
}

function afterSuccess(response, init)
{
	if(response && response.status !== undefined && response.status == true) {
		window.governateArea = response.list;
		updateAddressArea(init)
	} 
    
}

function getGovernateEl()
{
	return document.querySelector('[id$="_'+parentFieldName()+'"]');
}

function getAreaSelectorEl()
{
	return document.querySelector('[id$="_'+childFieldName()+'"]');
}

function getInitAreaValue()
{
	var selectedAddrssEl = $('input[name$="_addressList"]:checked');
	var isUnsaved = $('[id$="_unsavedAddressBook"]').is(':checked');
    if(!isUnsaved && selectedAddrssEl && selectedAddrssEl.length > 0 ) {
        var selectedAddress = selectedAddrssEl.data('address');
        var fieldName = childFieldName();
        if(selectedAddress && selectedAddress[fieldName] !== undefined) {
            return selectedAddress[fieldName];
        }
    }
		
	var initArea = document.querySelector('[id$="_initareavalue"]');
	if(initArea) {
		return initArea.value;
	} 
	return '';
}

function getInitGovernateValue()
{
	var selectedAddrssEl = $('input[name$="_addressList"]:checked');
	if(selectedAddrssEl && selectedAddrssEl.length > 0 ) {
		var selectedAddress = selectedAddrssEl.data('address');
		var fieldName = parentFieldName();
		if(selectedAddress && selectedAddress[fieldName] !== undefined) {
			return selectedAddress[fieldName];
		}
	}
	
	return '';
}

function getFormCountry()
{
	var countryEl = $('[name$="_country"]');
    if(countryEl && countryEl.length > 0) {
    	return countryEl.val();
    } 
    return '';
}

function parentFieldName()
{
	var config = SitePreferences.SITE_SPECIFIC_CONFIGS && JSON.parse(SitePreferences.SITE_SPECIFIC_CONFIGS);
	var country = getFormCountry();
	
	if(config && country && config.addressForm !== undefined && config.addressForm[country]!==undefined  && config.addressForm[country].parent !== undefined && config.addressForm[country].parent.trim() !='') {
		return config.addressForm[country].parent;
	} else {
		return 'governate';
	}
	
}

function childFieldName()
{
	var config = SitePreferences.SITE_SPECIFIC_CONFIGS && JSON.parse(SitePreferences.SITE_SPECIFIC_CONFIGS);
	var country = getFormCountry();
	if(config && country && config.addressForm !== undefined && config.addressForm[country]!==undefined  && config.addressForm[country].child !==undefined && config.addressForm[country].child.trim() !='') {
		return config.addressForm[country].child;
	} else {
		return 'area';
	}
}

function isDependentAddress()
{
	var config = SitePreferences.SITE_SPECIFIC_CONFIGS && JSON.parse(SitePreferences.SITE_SPECIFIC_CONFIGS);
	var country = getFormCountry();
	if(config && country && config.addressForm !== undefined && config.addressForm[country]!==undefined  && config.addressForm[country].child !==undefined && config.addressForm[country].child.trim() !='') {
		return true;
	} else {
		return false;
	}
}

function updateAddressArea(init)
{
	if(window.governateArea === undefined) {
		return;
	}
	
	if(init === undefined) {
		init = false;
	}
	var governate = getGovernateEl();
	if(!governate) {
		return;
	}
	var country = getFormCountry();
	if(!country) {
	    return;
	}
	country = country.toUpperCase();
	var areasList;
	if(window.governateArea[country] === undefined) {
	    areasList = window.governateArea[governate.value];
	} else {
	    areasList = window.governateArea[country][governate.value];
	}
	
	if(areasList === undefined || areasList.areas === undefined) {
		return;
	}
	var areaSelector = getAreaSelectorEl();
	var initValue = getInitAreaValue();
	var lists = areasList.areas;
	$(governate).trigger('blur');
	if(areaSelector && lists.length > 0) {
		areaSelector = getAreaSelectorEl();
		$(areaSelector).append('<option value="" class="select-option" label="' + Resources.SELECT_ADDRESS_AREA + '">' + Resources.SELECT_ADDRESS_AREA + '</option>');
		for(var i=0;i<lists.length;i++) {
			if(lists[i] && lists[i].trim()) {
				$(areaSelector).append('<option class="select-option" label="' + lists[i] + '">' + lists[i] + '</option>');
			}
		}
		if(initValue) {
			$(areaSelector).val(initValue);
		} else {
			$(areaSelector).prop('selectedIndex', 0).val('');
		}
		$(areaSelector).trigger('change');
	} else {
		removeAreaSelector();
		$(areaSelector).append('<option value="" class="select-option" label="' + Resources.SELECT_ADDRESS_AREA + '">' + Resources.SELECT_ADDRESS_AREA + '</option>');
	}
	updateFields();
}

function removeAreaSelector(init)
{
	if(init === undefined) {
		init = false;
	}
	var areaSelector = getAreaSelectorEl();
	var initArea = document.querySelector('[id$="_initareavalue"]');
	var initValue = '';
	if(init == true && initArea) {
		initValue = $(initArea).val();
	}
	
	if(areaSelector && areaSelector.length > 0) {
		if(!$(areaSelector).hasClass('select2-option')) {
			$(areaSelector).selectric('init');
		}
		$(areaSelector).empty();
		$(areaSelector).trigger('blur');
	}
}

function updateGovernateInfo()
{
	var governate = getGovernateEl();
	if(!governate) {
		return;
	}
	
	var governateVal = getInitGovernateValue();
	if(governateVal) {
		$(governate)
			.val(governateVal)
			.trigger('blur')
			.trigger('change');
	}
}

function initGovernateEvents()
{
	var governateSelector = getGovernateEl();
	if(governateSelector) {
		var initGovernateValue = governateSelector.value;
		var governateSelectorEl = $(governateSelector);
		if(!governateSelectorEl.hasClass('select2-option')) {
		    governateSelectorEl.off('change');
		}
		governateSelectorEl.on('change', function(e) {
			e.stopPropagation();
			if(initGovernateValue != $(this).val()) {
				updateGovernateArea();
				initGovernateValue = $(this).val();
			}
			if($(this).val() == '' && !governateSelectorEl.hasClass('select2-option')) {
			    $(this).selectric('refresh');
			}
		});
		formPrepare.validateForm();
	}
	initAreaField();
}

function initAreaField()
{
	var areaSelector = getAreaSelectorEl();
	if(areaSelector) {
		$(areaSelector).on('change', function(e) {
			e.stopPropagation();
			$(this).trigger('blur');
			formPrepare.validateForm();
		});
	}
}

function updateFields()
{
	var governateSelector = getGovernateEl();
	var areaSelector = getAreaSelectorEl();
	if(governateSelector) {
		$(governateSelector).trigger('blur');
		if (!$(governateSelector).hasClass('select2-option')) {
            $(governateSelector).selectric('refresh');
        }
		if(areaSelector) {
            $(areaSelector).trigger('blur');
            if (!$(areaSelector).hasClass('select2-option')) {
                $(areaSelector).selectric('refresh');
            }
        }
		formPrepare.validateForm();
	}
	
}
exports.init = function () {
	var governateSelector = getGovernateEl();
	if(governateSelector) {
		var initGovernateValue = governateSelector.value;
		var governateSelectorEl = $(governateSelector);
		if(!governateSelectorEl.hasClass('select2-option')) {
		    governateSelectorEl.off('change');
		}
		governateSelectorEl.on('change', function(e) {
			e.stopPropagation();
			if(initGovernateValue != $(this).val()) {
				updateGovernateArea();
				initGovernateValue = $(this).val();
			}
			if($(this).val() == '' && !governateSelectorEl.hasClass('select2-option')) {
                $(this).selectric('refresh');
			}
		});
		updateGovernateArea(true);
	}
	initAreaField();
}

function getAddressFields()
{
    return '[name*="_addressFields"]';
}

exports.updateGovernateArea = updateGovernateArea;
exports.updateGovernateInfo = updateGovernateInfo;
exports.initGovernateEvents = initGovernateEvents;
exports.updateFields = updateFields;
exports.getFormCountry=getFormCountry;
exports.getAddressFields=getAddressFields;
exports.isDependentAddress=isDependentAddress;


// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/helpers/address.utils.js